import FreemiumEventCreateSubscriptionUpsellStep from './FreemiumEventCreateSubscriptionUpsellStep';

export default FreemiumEventCreateSubscriptionUpsellStep;
